import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';

import { Login } from '../models/login.model';
import { AuthServerProvider } from './auth-jwt.service';
import { AccountService } from './account.service';
import { PaymentService } from './payment.service';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class LoginService {
  readonly #accountService = inject(AccountService);
  readonly #authServerProvider = inject(AuthServerProvider);
  readonly #paymentService = inject(PaymentService);

  public login(credentials: Login): Observable<User | null> {
    return this.#authServerProvider.login(credentials).pipe(mergeMap(() => this.#accountService.identity()));
  }

  public loginImpersonate(credentials: Login): Observable<User | null> {
    return this.#authServerProvider.loginImpersonate(credentials).pipe(mergeMap(() => this.#accountService.identity()));
  }

  public logout(): void {
    this.#paymentService.goToPayment = false;
    this.#authServerProvider.logout().subscribe({ complete: () => this.#accountService.authenticate(null) });
  }

  public loginAndFetchCustomer(credentials: Login): Observable<any> {
    return this.login(credentials).pipe(
      tap((account: User | null) => {
        if (account) {
          return of(account);
        } else {
          throw new Error('Account do not exist.');
        }
      })
    );
  }
}
